(($, Drupal, once) => {
  Drupal.behaviors.sidebarNavToggle = {
    attach(context) {
      once('sidebarNavToggle', 'html', context).forEach(() => {
        // store sidebar nav container
        const sidebarContainer = document.getElementById(
          'srs-sidebar-container',
        );
        // store sidebar nav toggler button
        const sidebarButton = document.getElementById(
          'sidebar-collapse-button',
        );

        // not related to the sidebar, just wanted this somewhere global
        const schoolYear = $('#edit-field-school-year-0-value').val();
        $('#edit-school-year-select').val(schoolYear);

        sidebarButton.addEventListener('click', () => {
          // check data-toggle-state attribute and store it's value.
          const sidebarState = sidebarButton.dataset.toggleState;
          if (sidebarState === 'open') {
            // add styling class and change toggle state
            sidebarContainer.classList.add('srs-sidebar-collapse');
            sidebarButton.dataset.toggleState = 'closed';
          } else {
            // add styling class and change toggle state
            sidebarContainer.classList.remove('srs-sidebar-collapse');
            sidebarButton.dataset.toggleState = 'open';
          }
        });
      });

      once('sidebarMobileToggle', 'html', context).forEach(() => {
        // const navbarCollapse = document.querySelector('#CollapsingNavbar');
        const navbarContainer = document.querySelector('#srsTopNav');
        const navbarToggler = document.querySelector('#navbarCollapseToggler');

        if (navbarToggler !== null) {
          navbarToggler.addEventListener('click', () => {
            // check aria-expanded attribute and store it's value.
            const navbarState = navbarToggler.getAttribute('aria-expanded');
            if (navbarState === 'true') {
              navbarContainer.classList.add('toggle-open');
            } else {
              navbarContainer.classList.remove('toggle-open');
            }
          });
        }
      });
    },
  };
})(jQuery, Drupal, once);
